import { Tag as AntdTag, Modal as AntdModal, Steps as AntdSteps, Card } from 'antd';
import { Row } from 'antd';
import styled, { CSSProperties, ThemedStyledFunction } from 'styled-components';

const CustomCardOutlined: CSSProperties = {
	marginTop: '16px',
	border: '1px dashed #e9e9e9',
	borderRadius: '6px',
	backgroundColor: '#fafafa',
	textAlign: 'center',
};

const StepsAction: CSSProperties = {
	marginTop: '24px',
};

const TagStyle: CSSProperties = {
	fontWeight: 'bold',
	fontSize: '14px',
	height: '32px',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
};

const ModalStyle: CSSProperties = {
	minWidth: '500px',
	width: '90%',
	maxWidth: '1100px',
};

const StepsStyle: CSSProperties = {
	marginTop: '24px',
};

function getStyled(properties: CSSProperties, element: ThemedStyledFunction<any, any, any>) {
	return element`
      ${Object.entries(properties)
				.map(([key, value]) => `${key.replace(/([A-Z])/g, '-$1').toLowerCase()}: ${value};`)
				.join('\n')}
    `;
}

export const StepsContentStyled = getStyled({ ...CustomCardOutlined, minHeight: 200 }, styled.div);
export const CardOutlinedStyled = getStyled(CustomCardOutlined, styled(Card));
export const StepsActionStyled = getStyled(StepsAction, styled(Row));
export const Tag = getStyled(TagStyle, styled(AntdTag));
export const Modal = getStyled(ModalStyle, styled(AntdModal));
export const Steps = getStyled(StepsStyle, styled(AntdSteps));
